import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subawardMonitoringActivities from '../../subaward-monitoring-activities'

export const RESOURCE = {
  payload: {
    description:
      'A specific compliance or oversight action related to subawards to ensure the subrecipient meets regulatory standards.',
    dimension: subawardMonitoringActivities.RESOURCE.payload,
    level: 0,
    name: 'Subaward Monitoring Activity',
    partialId: PartialId.Standard.create('activity'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
